(function () {
  var accountFallbackHref = '/account';
  var rusticoRed = '#5b0604';
  var chainVariantId = '58303696863619';
  var chainImageUrl = 'https://cdn.shopify.com/s/files/1/0952/7561/4595/files/Chaine1.jpg?v=1782050380';
  var accountIconSvg = '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="7.5" r="3.4"></circle><path d="M5.5 20c.9-4.1 3.2-6.1 6.5-6.1s5.6 2 6.5 6.1"></path></svg>';
  var cartIconSvg = '<span class="rustico-site-header__cart-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M7.25 8.75h9.5l-.62 9.2a1.55 1.55 0 0 1-1.55 1.45H9.42a1.55 1.55 0 0 1-1.55-1.45l-.62-9.2Z"></path><path d="M9.8 8.75V6.65a2.2 2.2 0 0 1 4.4 0v2.1"></path></svg></span>';

  function injectMobileHeaderFix() {
    var style = document.getElementById('rustico-mobile-header-fix-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'rustico-mobile-header-fix-styles';
      document.head.appendChild(style);
    }

    style.textContent =
      '.rustico-site-header__actions{display:flex!important;justify-content:flex-end!important;align-items:center!important;gap:10px!important;pointer-events:auto!important;}' +
      '.rustico-site-header__account,.rustico-account-icon-only,.rustico-site-header__cart{display:inline-flex!important;position:relative!important;align-items:center!important;justify-content:center!important;width:34px!important;max-width:34px!important;height:34px!important;min-width:34px!important;padding:0!important;margin:0!important;text-decoration:none!important;white-space:nowrap!important;overflow:visible!important;font-size:0!important;line-height:0!important;letter-spacing:0!important;text-indent:-9999px!important;color:transparent!important;pointer-events:auto!important;cursor:pointer!important;z-index:20!important;}' +
      '.rustico-site-header__account svg,.rustico-account-icon-only svg,.rustico-site-header__cart-icon,.rustico-site-header__cart-icon svg{display:block!important;width:23px!important;height:23px!important;min-width:23px!important;fill:none!important;stroke:#000!important;color:#000!important;stroke-width:1.45!important;stroke-linecap:round!important;stroke-linejoin:round!important;overflow:visible!important;text-indent:0!important;pointer-events:none!important;}' +
      '.rustico-site-header__account svg *,.rustico-account-icon-only svg *,.rustico-site-header__cart-icon svg *{fill:none!important;stroke:#000!important;stroke-width:1.45!important;stroke-linecap:round!important;stroke-linejoin:round!important;}' +
      '.rustico-site-header__cart-label{display:none!important;}' +
      '.rustico-site-header__cart-count{position:absolute!important;top:-4px!important;right:-6px!important;min-width:17px!important;width:auto!important;max-width:none!important;height:17px!important;padding:0 5px!important;border-radius:999px!important;background:#000!important;color:#fff!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;font-size:0!important;letter-spacing:0!important;line-height:1!important;text-indent:0!important;overflow:visible!important;transition:transform .22s ease,background-color .22s ease!important;pointer-events:none!important;}' +
      '.rustico-site-header__cart-count-number{font-size:10px!important;line-height:1!important;color:#fff!important;}' +
      '.rustico-site-header__cart.rustico-cart-bump .rustico-site-header__cart-count{transform:scale(1.2)!important;}' +
      '.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label{background:#fff!important;background-color:#fff!important;border:2px solid ' + rusticoRed + '!important;color:' + rusticoRed + '!important;box-shadow:none!important;transition:background-color .18s ease,border-color .18s ease,color .18s ease!important;}' +
      '.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label:hover{background:#fff!important;background-color:#fff!important;border-color:' + rusticoRed + '!important;color:' + rusticoRed + '!important;}' +
      '.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label:has(:checked),.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label.rustico-variant-selected{background:' + rusticoRed + '!important;background-color:' + rusticoRed + '!important;border-color:' + rusticoRed + '!important;color:#fff!important;}' +
      '.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label:has(:checked):hover{background:' + rusticoRed + '!important;background-color:' + rusticoRed + '!important;border-color:' + rusticoRed + '!important;color:#fff!important;}' +
      '.variant-picker .variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label input{cursor:pointer!important;}' +
      '.rustico-chain-addon{display:flex!important;align-items:center!important;gap:16px!important;width:100%!important;margin-top:16px!important;padding:14px 16px!important;border:1.5px solid rgba(91,6,4,.22)!important;border-radius:8px!important;background:#f8f4ec!important;color:#2f2f2f!important;cursor:pointer!important;transition:border-color .18s ease,background-color .18s ease!important;}' +
      '.rustico-chain-addon.rustico-chain-addon--checked{border-color:' + rusticoRed + '!important;background:#fff8f3!important;}' +
      '.rustico-chain-addon__check{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:28px!important;height:28px!important;min-width:28px!important;border:2px solid ' + rusticoRed + '!important;border-radius:6px!important;background:#fff!important;color:#fff!important;font-size:20px!important;line-height:1!important;font-weight:700!important;}' +
      '.rustico-chain-addon--checked .rustico-chain-addon__check{background:' + rusticoRed + '!important;}' +
      '.rustico-chain-addon__input{position:absolute!important;opacity:0!important;pointer-events:none!important;}' +
      '.rustico-chain-addon__body{display:flex!important;flex-direction:column!important;gap:3px!important;flex:1 1 auto!important;min-width:0!important;}' +
      '.rustico-chain-addon__heading{font-size:18px!important;line-height:1.15!important;font-weight:700!important;color:' + rusticoRed + '!important;}' +
      '.rustico-chain-addon__text{font-size:15px!important;line-height:1.2!important;color:#2f2f2f!important;}' +
      '.rustico-chain-addon__price{font-size:16px!important;line-height:1.2!important;font-weight:700!important;color:' + rusticoRed + '!important;}' +
      '.rustico-chain-addon__image{width:58px!important;height:58px!important;min-width:58px!important;object-fit:cover!important;border-radius:4px!important;}' +
      '.rustico-chain-addon__notice{margin-top:8px!important;font-size:13px!important;line-height:1.35!important;color:#5f5850!important;}' +
      '.rustico-chain-addon-loading{opacity:.72!important;pointer-events:none!important;}' +
      '@media screen and (max-width:749px){' +
      '.rustico-site-header__inner{grid-template-columns:42px minmax(0,1fr) 78px!important;column-gap:6px!important;min-height:92px!important;padding:12px 14px!important;}' +
      '.rustico-site-header__mobile-menu{grid-column:1!important;justify-self:start!important;align-self:center!important;width:34px!important;}' +
      '.rustico-site-header__hamburger{display:inline-flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:center!important;gap:5px!important;width:34px!important;height:34px!important;padding:0!important;color:#000!important;}' +
      '.rustico-site-header__hamburger span{display:block!important;width:24px!important;height:2px!important;margin:0!important;border-radius:999px!important;background:#000!important;}' +
      '.rustico-site-header__hamburger span+span{margin-top:0!important;}' +
      '.rustico-site-header__logo-link{grid-column:2!important;justify-self:center!important;min-width:0!important;max-width:100%!important;}' +
      '.rustico-site-header__logo{width:clamp(132px,38vw,178px)!important;max-width:100%!important;}' +
      '.rustico-site-header__actions{grid-column:3!important;justify-self:end!important;gap:6px!important;min-width:78px!important;}' +
      '.rustico-site-header__account,.rustico-account-icon-only,.rustico-site-header__cart{width:32px!important;max-width:32px!important;height:32px!important;min-width:32px!important;}' +
      '.rustico-site-header__account svg,.rustico-account-icon-only svg,.rustico-site-header__cart-icon,.rustico-site-header__cart-icon svg{width:23px!important;height:23px!important;min-width:23px!important;}' +
      '.rustico-site-header__mobile-panel{top:var(--rustico-fixed-stack-height,92px)!important;}' +
      '.rustico-chain-addon{gap:12px!important;padding:12px!important;}' +
      '.rustico-chain-addon__heading{font-size:16px!important;}' +
      '.rustico-chain-addon__image{width:52px!important;height:52px!important;min-width:52px!important;}' +
      '}';
  }

  function isAccountLink(link) {
    var href = (link.getAttribute('href') || '').toLowerCase();
    var text = (link.textContent || '').trim().toLowerCase();
    return href.indexOf('/account') !== -1 || href.indexOf('account.') !== -1 || text === 'se connecter' || text === 'connexion';
  }

  function getSafeAccountHref(account) {
    var href = account.getAttribute('href') || '';
    if (href && href !== '#' && href.toLowerCase().indexOf('javascript:') !== 0) return href;
    return accountFallbackHref;
  }

  function ensureCartMarkup(cartLink) {
    var existingCount = cartLink.querySelector('.rustico-site-header__cart-count-number');
    var count = existingCount ? existingCount.textContent : (cartLink.textContent || '0');
    count = String(count).replace(/[^0-9]/g, '') || '0';
    cartLink.classList.add('rustico-site-header__cart');
    cartLink.setAttribute('aria-label', 'Panier (' + count + ')');
    cartLink.innerHTML = cartIconSvg + '<span class="rustico-site-header__cart-count" aria-hidden="true"><span class="rustico-site-header__cart-count-number">' + count + '</span></span>';
  }

  function normalizeHeaderActions() {
    document.querySelectorAll('.rustico-site-header__actions').forEach(function (actions) {
      var accountLinks = [];
      actions.querySelectorAll('a').forEach(function (link) {
        if (isAccountLink(link)) accountLinks.push(link);
      });

      var account = accountLinks[0];
      if (account) {
        var accountHref = getSafeAccountHref(account);
        accountLinks.slice(1).forEach(function (duplicate) { duplicate.remove(); });
        account.className = 'rustico-site-header__icon-button rustico-site-header__account rustico-account-icon-only';
        account.href = accountHref;
        account.setAttribute('href', accountHref);
        account.setAttribute('aria-label', 'Compte client');
        account.removeAttribute('data-rustico-account-login');
        account.innerHTML = accountIconSvg;
      }

      var cart = actions.querySelector('.rustico-site-header__cart, a[href*="/cart"]');
      if (cart) ensureCartMarkup(cart);

      if (account && cart) {
        actions.insertBefore(account, cart);
      }
    });
  }

  function updateRusticoMenuLabels() {
    var labelsByHref = {
      '/products/rustico-cap': 'Rustico Cap',
      '/products/collezione-denaro-tee': 'T-shirt Denaro'
    };

    Object.keys(labelsByHref).forEach(function (href) {
      document.querySelectorAll('a[href="' + href + '"]').forEach(function (link) {
        link.textContent = labelsByHref[href];
      });
    });
  }

  function normalizeCount(value) {
    var count = Number(String(value).replace(/[^0-9]/g, ''));
    return Number.isFinite(count) ? count : 0;
  }

  function markSelectedVariants() {
    document.querySelectorAll('.variant-picker .variant-option__button-label').forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      label.classList.toggle('rustico-variant-selected', Boolean(input && input.checked));
    });
  }

  function removeDefaultVariantLabels() {
    document.querySelectorAll('.cart-items__size-box').forEach(function (box) {
      var value = (box.querySelector('strong') || box).textContent.trim().toLowerCase();
      if (value === 'default title') box.remove();
    });

    document.querySelectorAll('.cart-items__variant, .cart-items__properties').forEach(function (row) {
      var text = row.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'default title' || text === 'title: default title' || text === 'taille: default title' || text === 'size: default title') row.remove();
    });
  }

  function isPendentifPage() {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf('/products/pendente') !== -1 || path.indexOf('/products/pendentif') !== -1) return true;

    var title = '';
    var titleElement = document.querySelector('h1, [class*="product-title"], [data-testid*="product-title"]');
    if (titleElement) title += ' ' + titleElement.textContent;
    var ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) title += ' ' + (ogTitle.getAttribute('content') || '');
    var description = document.querySelector('[class*="product-description"], .rte');
    var descriptionText = description ? description.textContent : '';

    return /pendente|pendentif/i.test(title) || /chaine non comprise|chaîne non comprise/i.test(descriptionText);
  }

  function setChainAddonState(addon, checked) {
    addon.classList.toggle('rustico-chain-addon--checked', checked);
    var check = addon.querySelector('.rustico-chain-addon__check');
    if (check) check.textContent = checked ? '✓' : '';
  }

  function insertPendentifChainAddon() {
    if (!isPendentifPage()) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var scope = form.closest('product-form-component') || form.parentElement || form;
      if (!scope || scope.querySelector('.rustico-chain-addon')) return;

      var addon = document.createElement('label');
      addon.className = 'rustico-chain-addon';
      addon.innerHTML =
        '<input class="rustico-chain-addon__input" type="checkbox" aria-label="Ajouter la chaîne 50cm">' +
        '<span class="rustico-chain-addon__check" aria-hidden="true"></span>' +
        '<span class="rustico-chain-addon__body">' +
          '<span class="rustico-chain-addon__heading">Je complète ma commande</span>' +
          '<span class="rustico-chain-addon__text">Chaîne 50cm</span>' +
          '<span class="rustico-chain-addon__price">+25€</span>' +
        '</span>' +
        '<img class="rustico-chain-addon__image" src="' + chainImageUrl + '" alt="Chaîne 50cm">';

      var input = addon.querySelector('input');
      input.addEventListener('change', function () { setChainAddonState(addon, input.checked); });

      var insertAfter = form;
      var submitButton = form.querySelector('button[type="submit"], [type="submit"], button[name="add"]');
      if (submitButton && submitButton.closest('.shopify-payment-button')) insertAfter = submitButton.closest('.shopify-payment-button');
      insertAfter.insertAdjacentElement('afterend', addon);
    });
  }

  function shouldAddChainWithForm(form) {
    if (!isPendentifPage()) return false;
    var scope = form.closest('product-form-component') || form.parentElement || document;
    var checkbox = scope.querySelector('.rustico-chain-addon__input');
    return Boolean(checkbox && checkbox.checked);
  }

  function getFormQuantity(form) {
    var formData = new FormData(form);
    var raw = formData.get('quantity') || (form.querySelector('[name="quantity"]') || {}).value || 1;
    var quantity = parseInt(raw, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  async function addPendentifWithChain(form) {
    var scope = form.closest('product-form-component') || form.parentElement || form;
    var addon = scope.querySelector('.rustico-chain-addon');
    var submitButton = form.querySelector('button[type="submit"], [type="submit"], button[name="add"]');
    var originalText = submitButton ? submitButton.textContent : '';
    var quantity = getFormQuantity(form);

    if (addon) addon.classList.add('rustico-chain-addon-loading');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Ajout en cours...';
    }

    try {
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(chainVariantId), quantity: quantity, properties: { '_Ajout': 'Chaîne 50cm avec pendentif' } }] })
      });
      await syncRusticoCartCount();
    } catch (error) {
      form.submit();
      return;
    } finally {
      if (addon) addon.classList.remove('rustico-chain-addon-loading');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText || 'Ajouter au panier';
      }
    }
  }

  function setRusticoCartCount(count) {
    if (!Number.isFinite(count)) return;

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var countElement = bubble.querySelector('span[aria-hidden="true"]');
      if (countElement) countElement.textContent = count;
      bubble.classList.toggle('hidden', count <= 0);
    });

    document.querySelectorAll('.rustico-site-header__cart').forEach(function (cartLink) {
      ensureCartMarkup(cartLink);
      var countElement = cartLink.querySelector('.rustico-site-header__cart-count-number');
      var countWrapper = cartLink.querySelector('.rustico-site-header__cart-count');
      countElement.textContent = count;
      countWrapper.classList.toggle('hidden', count <= 0);
      cartLink.setAttribute('aria-label', 'Panier (' + count + ')');
      cartLink.classList.add('rustico-cart-bump');
      window.setTimeout(function () { cartLink.classList.remove('rustico-cart-bump'); }, 260);
    });
  }

  async function syncRusticoCartCount() {
    try {
      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (response) {
        return response.json();
      });
      setRusticoCartCount(Number(cart.item_count || 0));
    } catch (error) {}
  }

  function scheduleCartSync(delay) {
    window.setTimeout(syncRusticoCartCount, delay || 120);
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    if (shouldAddChainWithForm(form)) {
      event.preventDefault();
      event.stopPropagation();
      await addPendentifWithChain(form);
      return;
    }

    if (form.closest('product-form-component')) {
      scheduleCartSync(250);
      scheduleCartSync(700);
      return;
    }

    event.preventDefault();

    try {
      var formData = new FormData(form);
      await fetch('/cart/add.js', { method: 'POST', body: formData });
      await syncRusticoCartCount();
    } catch (error) {
      form.submit();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var account = event.target.closest('.rustico-site-header__account, .rustico-account-icon-only');
    if (account) {
      var href = getSafeAccountHref(account);
      if (href) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = href;
        return;
      }
    }

    if (event.target.closest('.variant-picker .variant-option__button-label')) {
      window.setTimeout(markSelectedVariants, 0);
      window.setTimeout(markSelectedVariants, 120);
    }

    if (event.target.closest('form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"]')) {
      scheduleCartSync(500);
      scheduleCartSync(1000);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('.variant-picker')) {
      markSelectedVariants();
    }
  }, true);

  function runRusticoHeaderFixes() {
    injectMobileHeaderFix();
    normalizeHeaderActions();
    updateRusticoMenuLabels();
    markSelectedVariants();
    removeDefaultVariantLabels();
    insertPendentifChainAddon();
    syncRusticoCartCount();
    document.querySelectorAll('.rustico-site-header__cart-count').forEach(function (countWrapper) {
      setRusticoCartCount(normalizeCount(countWrapper.textContent));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRusticoHeaderFixes);
  } else {
    runRusticoHeaderFixes();
  }

  window.setTimeout(runRusticoHeaderFixes, 250);
  window.setTimeout(runRusticoHeaderFixes, 1000);
  window.setTimeout(removeDefaultVariantLabels, 1600);
  document.addEventListener('shopify:section:load', runRusticoHeaderFixes);
  document.addEventListener('shopify:section:select', runRusticoHeaderFixes);
})();
